import React, { useState } from 'react';
import { IMaskInput } from 'react-imask';
import { FormWrapper, InputWrapper } from './Wrappers';
import { InputBaseComponentProps } from '@mui/material';
import { genericMemo } from './Types'


export function asValidCurrency(amount: number | null): number | null {
  return isValidCurrency(amount) ? amount : null //&& amount.replace(/[^1-9]/g, '')
}

export function isValidCurrency(amount: number | null): boolean {
  return !!amount //&& amount.replace(/[^1-9]/g, '')
}

function CurrencyInputIMask({onChange, ...props}: {onChange?: (newValue: string) => void} & InputBaseComponentProps) {
  return (
    <IMaskInput
      {...props}
      mask={Number}
      min={0}
      max={9999999.99}
      thousandsSeparator=' '
      padFractionalZeros= {true}
      unmask={true}
      onAccept={(value, _, event) => {if (event !== undefined && onChange !== undefined) onChange(value) }}
    />
  )
}


const CurrencyInputWrapped = InputWrapper(CurrencyInputIMask)

const fromNumberToString = (num: number | null) => num === null ? '' : num.toFixed(2)
const fromStringToNumber = (str: string) => str === '' ? null : Number(str)

function CurrencyInputRaw({onChange, value, ...props}: {onChange: (newValue: number | null) => void, value: number | null}) {
  const [stringValue, setStringValue] = useState(fromNumberToString(value))
  
  if (value !== fromStringToNumber(stringValue)) {
    setStringValue(fromNumberToString(value))
  }
  return (
    <CurrencyInputWrapped
      {...props}
      value={stringValue}
      onChange={newStringValue => { setStringValue(newStringValue); onChange(fromStringToNumber(newStringValue)) }}
    />
  )
}

const CurrencyInput = genericMemo(FormWrapper({Component: CurrencyInputRaw, validationFunction: isValidCurrency}))

export default CurrencyInput
